var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCrossSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 0.700106C12.9135 0.313506 12.2867 0.313506 11.9001 0.700106L7.00011 5.60011L2.10011 0.700106C1.71351 0.313506 1.08671 0.313506 0.700106 0.700106C0.313506 1.08671 0.313506 1.71351 0.700106 2.10011L5.60011 7.00011L0.700106 11.9001C0.313506 12.2867 0.313506 12.9135 0.700106 13.3001C1.08671 13.6867 1.71351 13.6867 2.10011 13.3001L7.00011 8.40011L11.9001 13.3001C12.2867 13.6867 12.9135 13.6867 13.3001 13.3001C13.6867 12.9135 13.6867 12.2867 13.3001 11.9001L8.40011 7.00011L13.3001 2.10011C13.6867 1.71351 13.6867 1.08671 13.3001 0.700106Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossSmall);
export default __webpack_public_path__ + "static/media/icon-cross-small.cabbb69e722f5a9ebb3c9460e64dead0.svg";
export { ForwardRef as ReactComponent };